<div class="button">
  <a class="rounded {{class}}" role="button" (click)="onClick($event)">
    <co-image [width]="iconWidth" [height]="iconHeight" type="svg" [key]="icon" [imageSet]="imageSet"></co-image>
  </a>
</div>
